import * as styles from './CategoryCopy.module.scss';

import { FC, useContext } from 'react';
import classNames from 'classnames';
import dynamic from 'next/dynamic';

import RightArrowDecal from '../RightArrowDecal';
import { SiteContext } from '@/contexts/site-context';

/**
 * @returns `true` if the `slug` has additional content
 */
export const hasAdditionalContent = (slug: string) => Object.keys(ContentBySlug).includes(slug);

type Slug = keyof typeof ContentBySlug;

const ContentBySlug = {
  'air-conditioning-contractors': dynamic(() => import('@/data/category_copy/air-conditioning-contractors')),
  'appliance-repair': dynamic(() => import('@/data/category_copy/appliance-repair')),
  'drains': dynamic(() => import('@/data/category_copy/drains')),
  'el': dynamic(() => import('@/data/category_copy/el')),
  'electrical-service': dynamic(() => import('@/data/category_copy/electrical-service')),
  'electrical-services': /* same as electrical-service */ dynamic(() => import('@/data/category_copy/electrical-service')),
  'electrician': /* same as electrical-service */ dynamic(() => import('@/data/category_copy/electrical-service')),
  'electricians': /* same as electrical-service */ dynamic(() => import('@/data/category_copy/electrical-service')),
  'exterminators': dynamic(() => import('@/data/category_copy/exterminators')),
  'flea-exterminators': dynamic(() => import('@/data/category_copy/flea-exterminators')),
  'garbage-disposal': dynamic(() => import('@/data/category_copy/garbage-disposal')),
  'locksmiths': dynamic(() => import('@/data/category_copy/locksmiths')),
  'pl': dynamic(() => import('@/data/category_copy/pl')),
  'plumbers-gas-lines': dynamic(() => import('@/data/category_copy/plumbers-gas-lines')),
  'plumbers-toilets': dynamic(() => import('@/data/category_copy/plumbers-toilets')),
  'plumbers-water-heaters': dynamic(() => import('@/data/category_copy/plumbers-water-heaters')),
  'plumbers': dynamic(() => import('@/data/category_copy/plumbers')),
  'plumbing-service': /* same as plumbers */ dynamic(() => import('@/data/category_copy/plumbers')),
  'roofers': dynamic(() => import('@/data/category_copy/roofers')),
  'windows': dynamic(() => import('@/data/category_copy/windows'))
};

interface CategoryCopyProps {
  slug: Slug;
  withImage?: boolean;
}

/**
 * @param slug `url_slug` of the category mapped to content from `data/category_copy`
 * @param withImage removes top padding to reduce white space when an image is above content
 *
 * __You can use the exported function `hasAdditionalContent` to check if a `url_slug` has a component__
 */
export const CategoryCopy: FC<CategoryCopyProps> = ({ slug, withImage }) => {
  const [site] = useContext(SiteContext);
  const Content = slug ? ContentBySlug[slug] : null;

  if (!Content) return null;

  // location prefixed with space for accurate punctuation
  const location = site.location ? ` ${site.location}` : '';

  return (
    <div className={classNames(styles['category-copy-container'], withImage && styles['has-category-dude-image'])}>
      <RightArrowDecal />
      <div className="container">
        <Content location={location} />
      </div>
    </div>
  );
};
